/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CustomerNotificationType {
  DRIVER_ON_WAY="DRIVER_ON_WAY",
UPDATE_ETA="UPDATE_ETA",
SKIPPED="SKIPPED",
DELIVERED="DELIVERED",
CANCELLED="CANCELLED"
}

/**
* CustomerNotificationType
*/
export const CustomerNotificationTypeEnumType = types.enumeration("CustomerNotificationType", [
        "DRIVER_ON_WAY",
  "UPDATE_ETA",
  "SKIPPED",
  "DELIVERED",
  "CANCELLED",
      ])
